<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13,4.009999990463257C13,3.459999990463257,12.55,3.009999990463257,12,3.009999990463257C12,3.009999990463257,4,3.009999990463257,4,3.009999990463257C3.45,3.009999990463257,3,3.459999990463257,3,4.009999990463257C3,4.169999990463257,3.05,4.319999990463257,3.11,4.449999990463256C3.11,4.449999990463256,3.1,4.449999990463256,3.1,4.449999990463256C3.1,4.449999990463256,7.1,12.449999990463256,7.1,12.449999990463256C7.1,12.449999990463256,7.11,12.449999990463256,7.11,12.449999990463256C7.27,12.779999990463256,7.6,13.009999990463257,8,13.009999990463257C8.4,13.009999990463257,8.719999999999999,12.779999990463256,8.89,12.449999990463256C8.89,12.449999990463256,8.9,12.449999990463256,8.9,12.449999990463256C8.9,12.449999990463256,12.9,4.449999990463256,12.9,4.449999990463256C12.9,4.449999990463256,12.89,4.449999990463256,12.89,4.449999990463256C12.95,4.309999990463257,13,4.169999990463257,13,4.009999990463257C13,4.009999990463257,13,4.009999990463257,13,4.009999990463257Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'SymbolTriangleDown',
} as DefineComponent
</script>
